function accordionItemMapper({ __typename, ...entity }) {
  return {
    type: 'accordion_item',
    ...entity,
  }
}

export default accordionItemMapper
